import { SiteMap } from '~/constants';
import type { SiteMapItems } from '~/models/siteMap';

export const getSiteMapItem = (path: string) => {
  const trimPath = (pathToTrim: string) => pathToTrim.replace(/\//g, '');
  const arePathsEqual = (path1: string, path2: string) => trimPath(path1) === trimPath(path2);

  const keys = Object.keys(SiteMap) as Array<keyof SiteMapItems>;
  const child = keys.find((key) => arePathsEqual(SiteMap[key].Path, path));

  if (!child) {
    return null;
  }

  return SiteMap[child];
};
